import createReactClass from 'create-react-class';
import React from 'react';
import { CompareGuidList } from '../components/compareGuidList';


//stores
import { compareDetailsStore } from '../stores/compareDetails';

function getStateFromStores() {
    return {
        guids: compareDetailsStore.getCompareGuids(),
        guidListLoading: compareDetailsStore.guidListLoading(),
        isOpened: false
    };
}

export const CompareGuidDetailsView = createReactClass({
    componentDidMount: function () {
        compareDetailsStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        compareDetailsStore.subscribe(this._onChange);
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    render: function () {
        var guidList;
        if (this.state) {
            guidList = getGuidList(this.state);
        }

        return (
            <div id="compareItemGuids" style={{ backgroundColor: "#b0c4de" }}>
                <div id="guidList">
                    {guidList}
                </div>
            </div>
        );
    }
});

function getGuidList(state) {
    return <CompareGuidList loading={state.guidListLoading} data={state.guids} />
}